<template>
    <div class="video-3"
        :style="{ cursor: 'url(' + exitCursor + '), auto'}"
    >
        <VideoViewer :url="this.videoUrl" :videoRescaledSize="this.videoRescaledSize" /> 
    </div>
</template>


<script>

import VideoViewer from "@/components/VideoViewer.vue";

export default {
    name: "Video3",
    components: {
        VideoViewer
    },
    data: function() {
        return {
            exitCursor: require('@/assets/cursors/EXIT.svg'),
            videoSize: [1920, 1200],
            scale: [1, 1],
            videoRescaledSize: [192, 1200]
        }
    },
    computed: {
        videoUrl: function() {
            let urlStart = "https://player.vimeo.com/video/453504912?autoplay=1#t=";
            urlStart += Math.floor(Math.random() * 11) + 'm' + 2 +'s';
            return urlStart;
        } 
    },
    methods: {
        setScaling() {
            let vidSizeRatio = (this.videoSize[0]/this.videoSize[1]);
            let screenRatio = window.innerWidth/window.innerHeight;
            let modHeight = this.videoSize[1] * (window.innerWidth/this.videoSize[0]);
            let modWidth = this.videoSize[0] * (window.innerHeight/this.videoSize[1]);
            let height = ((screenRatio > vidSizeRatio) ? modHeight : window.innerHeight);
            let width = ((screenRatio > vidSizeRatio) ? window.innerWidth : modWidth);
            this.scale = [width/this.videoSize[0], height/this.videoSize[1]];
            this.videoRescaledSize = [width, height];
      },
    },
    created() {
        this.setScaling();
        window.addEventListener("resize", this.setScaling);
    },
    destroyed() {
      window.removeEventListener("resize", this.setScaling);
    },
}
</script>